/**
 * Article metadata for the knowledge base.
 *
 * Discovered automatically by `generate-kb-catalog.mjs` (runs on `yarn start` and
 * `yarn build`). The slug must match this folder name.
 */
export const meta = {
  slug: 'health-checks',
  title: 'How uptime checks work',
  category: 'Status pages',
  summary:
    'What PulseWatch sends to your URL, what counts as healthy, how often checks run, and how to build a good health endpoint.',
  keywords: ['uptime check', 'health check', 'HTTP', 'monitoring', 'interval', 'timeout', 'User-Agent', 'firewall'],
};

export const loadComponent = () => import('./health-checks.component').then((m) => m.HealthChecksArticleComponent);
